export default __webpack_public_path__ + "static/media/stl_lower_outline.e9bc91d1.svg";